export default __webpack_public_path__ + "static/media/PreRoleCloudTrail.2a38a6a0.md";